export default "__VITE_ASSET__BaUf6KGe__"